import {
  apiDeleteUseFromMeter,
  apiPatchUseFromMeter,
  apiPostUseFromMeter
} from '../../api/Argentia/endpoints/meters/meters.api'
import { UseModel } from '../../api/Argentia/model/contracts'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'
import { UseModelPatch } from './uses.model'

export const createUseFromMeter = async (
  newUse: UseModel,
  meterID: number
): Promise<ServiceResponse<UseModel | undefined>> => {
  return apiPostUseFromMeter(newUse, meterID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteUseFromMeter = async (
  useID: number,
  meterID: number
): Promise<ServiceResponse<any>> => {
  return apiDeleteUseFromMeter(useID, meterID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updateUseFromMeter = async (
  use: UseModelPatch,
  meterID: number
): Promise<ServiceResponse<UseModel | undefined>> => {
  return apiPatchUseFromMeter(use, meterID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
